import { parseDate } from '@internationalized/date';

import { DatePickerField } from '@src/design-system/molecules/date-picker-field';
import type { TDynamicFilterProps } from '../filter-popover-content/dynamic-filters/dynamic-filter-value-input';

export function DynamicDateFilter({
  values,
  onChange,
  addOrEditDynamicFilter,
}: TDynamicFilterProps) {
  const datePickerValue = values?.[0] ? parseDate(values[0]) : null;

  return (
    <DatePickerField
      inputProps={{ size: 'sm' }}
      label=''
      onChange={(newDate) => {
        addOrEditDynamicFilter([newDate!.toString()]);
        onChange([newDate!.toString()]);
      }}
      value={datePickerValue}
    />
  );
}
